var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsNavActive = function SvgNotificationsNavActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.08 16.949c.966 0 1.75-.782 1.754-1.75v0a1.85 1.85 0 0 0-.546-1.31l-1.162-1.163V9.27A5.118 5.118 0 0 0 12 4.15v0a5.12 5.12 0 0 0-5.117 5.12v3.453l-1.162 1.163a1.851 1.851 0 0 0-.546 1.31v0c.003.968.787 1.75 1.754 1.75z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.634 19.85h2.73"
  })));
};
export { SvgNotificationsNavActive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNGJiZjcyZTVmNWI5M2FhYWI3ZDY5ZjZlNTc3MTYxM2Euc3ZnIjs=";